module.exports = __webpack_public_path__ + "img/13.c16fa880.jpg";